import styled from "styled-components";
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin-bottom: 0.5rem;

  .titulo-label {
    display: flex;
    justify-content: space-between;
  }

  .Label_title_p {
    margin-bottom: 0.25rem;
  }
  
  .w1 {
    padding-right: 0.15rem !important;
    width: 5rem;

    .top-header {
      display: flex;
      justify-content: center !important;
      width: 100% !important;
      height: 2rem !important;
      padding: 0.5rem 0rem 0.5rem 0rem !important;
    }
  }

  .icon-button {
    cursor: pointer;
    margin: 0 0.1rem;
  }
`;

export const CardAtividade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 19rem;
  margin-top: 0.7rem;
  overflow: auto;

  .card-atv-header {

  }

  .card-atv-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: -0.3rem;

    .top-header {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      height: 2rem;
    }

    .padding-left {
      padding: 0;
      padding-left: 0.7rem !important;
    }

    .row-top {
      margin-top: 0rem !important;
      display: flex;
      flex-direction: row;
    }

    .w1 {
      padding-right: 0.15rem !important;
      width: 5rem;
    }

    .w2 {
      padding-right: 0.15rem !important;
      width: 20rem;

      Input{
        border-top-left-radius: 0.5rem !important;
        border-bottom-left-radius: 0.5rem !important;
      }
    }

    .w3 {
      padding-right: 0.15rem !important;
      width: 8rem;
    }

    .w4 {
      padding-right: 0.15rem !important;
      width: 7rem;
    }

    .w5 {
      padding-right: 0.15rem !important;
      width: 24.2rem;
      margin-right: 0.8rem;

      Input{
        border-top-right-radius: 0.5rem !important;
        border-bottom-right-radius: 0.5rem !important;
      }
    }

    .row {
      width: auto;
    
      select, input, TextArea {
        width: 100%;
        margin-top: 0rem;
        border-radius: 0;
        height: 2.5rem;
      }

      TextArea:focus {
        height: 9.5rem !important;
      }

      .list-analista {
        display: flex;
        flex-direction: column;

        .item-analista {
          margin-top: 0.5rem;

          .icon-button {
            border: none;
            cursor: pointer;
            background: ${Colors.Color1};
            color: ${Colors.Color7};
            font-size: 1.125rem;
            margin-right: 0.3rem;
          }

          .padding-right {
            padding-right: 1rem !important;
          }

          .col {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding: 0rem;

            p {
              font-size: 0.75rem;
              color: ${Colors.Color7};
              font-weight: 500;
              margin-left: 0.5rem;
              width: 11rem;
            }
          }
        }
      }
    }

    .geraProjeto {
    
      input, TextArea {
        width: 100%;
        margin-top: 0rem !important;
      }
    }
  }

  .sub-atividade {
    background: ${Colors.Color22};
    border-radius: 0.6rem;
    padding-bottom: 0.6rem;
    margin-bottom: 1rem;
    margin-left: 1rem;

    .top-header {
      button {
        width: 1.8rem !important;
        padding: 0 !important;
        height: 1.8rem !important;
        font-size: 1.5rem !important;
        line-height: 1rem !important;
        color: #fff !important;
      }
    }

    .titulos-tab {
      display: flex;
      flex-direction: row;
      margin-bottom: 0.25rem;
      background: ${Colors.Color23};
      color: ${Colors.Color9};
      border-radius: 0.5rem;

      span {
        color: ${Colors.Color9};
      }

      .w1 {
        width: 4.7rem !important;
      }
      
      .titulo {
        font-size: 0.75rem;
        font-weight: 700;
        margin-left: 0.5rem;
      }

      .atividade {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 20rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .data-prev-inicio {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 8rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .data-prev-entrega {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 8rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .data-entrega {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 8rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .hora-total {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 8rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .hora-lib {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 8rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .trav-os {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 8rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .hora-dia {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 7rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .hora-inicial {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 7rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .hora-final {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 7rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .desc {
        height: 2.5rem;
        padding: 0.5rem 0rem 0.5rem 0.5rem;
        display: flex;
        align-items: center;
        width: 23.2rem;
        margin-right: 0.8rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }
    }
  }
`;

export const CardTituloAtividade = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.25rem;
  background: ${Colors.Color4};
  color: ${Colors.Color9};
  border-radius: 0.5rem;
  height: 2.5rem;

  .col-atv {
    padding: 0rem 0.4rem 0rem 0.4rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      line-height: 1.2rem;
    }
  }

  .col-atv.center {
    justify-content: center;
  }
  
  .col-1 {
    width: 5rem;
  }

  .col-2 {
    width: 10rem;
  }

  .col-3 {
    width: 15rem;
  }

  .col-4 {
    width: 20rem;
  }
  
  .col-5 {
    width: 25rem;
  }

  .col-6 {
    width: 30rem;
  }

  .icon-button {
    border: none;
    cursor: pointer;
    background: ${Colors.Color1};
    color: ${Colors.Color7};
    font-size: 1.125rem;
  }
`;

export const CardOSAtividade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.3rem;

  .row-top {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    
    select, input, TextArea {
      width: 100%;
      margin: 0rem !important;
      border-radius: 0;
      height: 2.5rem;
    }

    TextArea:focus {
      height: 9.5rem !important;
    }
  }

  .col-atv {
    padding: 0rem 0.1rem 0rem 0.1rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      margin-left: 0.5rem;
      line-height: 1.2rem;
    }
  }

  .col-atv.center {
    justify-content: center;
  }
  
  .col-1 {
    width: 5rem;
  }

  .col-2 {
    width: 10rem;
  }

  .col-3 {
    width: 15rem;
  }

  .col-4 {
    width: 20rem;
  }
  
  .col-5 {
    width: 25rem;
  }

  .col-6 {
    width: 30rem;
  }

  .sub-atividade {
    background: ${Colors.Color22};
    border-radius: 0.6rem;
    padding-bottom: 0.6rem;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
    margin-left: 0.8rem;
  }
`;

export const CardTituloItemAtividade = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.25rem;
  background: ${Colors.Color23};
  color: ${Colors.Color9};
  border-radius: 0.5rem;
  height: 2.5rem;

  .col-atv-item {
    padding: 0rem 0.4rem 0rem 0.4rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      line-height: 1.2rem;
    }
  }

  .col-atv-item.center {
    justify-content: center;
  }
  
  .col-1 {
    width: 5rem;
  }

  .col-2 {
    width: 10rem;
  }

  .col-3 {
    width: 15rem;
  }

  .col-4 {
    width: 20rem;
  }
  
  .col-5 {
    width: 25rem;
  }

  .col-6 {
    width: 30rem;
  }

  .icon-button {
    border: none;
    cursor: pointer;
    background: ${Colors.Color1};
    color: ${Colors.Color7};
    font-size: 1.125rem;
  }
`;

export const CardOSItemAtividade = styled.div`
  background: ${Colors.Color22};
  border-radius: 0.6rem;
  padding-bottom: 0.3rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .row-top {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    select, input, TextArea {
      width: 100%;
      margin: 0rem !important;
      border-radius: 0;
      height: 2.5rem;
    }

    TextArea:focus {
      height: 9.5rem !important;
    }
  }

  .col-atv-itrem {
    padding: 0rem 0.1rem 0rem 0.1rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      margin-left: 0.5rem;
      line-height: 1.2rem;
    }
  }

  .col-atv-item.center {
    justify-content: center;
  }
`;
